import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { VendorService } from '../../../services/vendor.service';

@Component({
  selector: 'app-add-vendor-bank-lookup',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './add-vendor-bank-lookup.component.html',
  styleUrl: './add-vendor-bank-lookup.component.scss'
})
export class AddVendorBankLookupComponent implements OnInit {

  constructor(private dialogService: DialogService,
    public ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private vendorService: VendorService
  ) { }

  submitted: boolean = false;
  loader: boolean = false;
  isEditMode: boolean = false;

  ngOnInit(): void {
    const bank = this.config.data?.bank;

    this.VendorBankForm.patchValue({
      VendorId: this.config.data?.VendorId,
      VendorCode: this.config.data?.VendorCode
    });

    if (bank) {
      this.isEditMode = true;

      this.VendorBankForm.patchValue({
        VendorBankAccountId: bank.vendorBankAccountId,
        AccountHolderName: bank.accountHolderName,
        BankName: bank.bankName,
        AccountNumber: bank.accountNumber,
        IFSC: bank.ifsc
      });
    }
  }

  get formControls() {
    return this.VendorBankForm.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.VendorBankForm.invalid) {
      isValid = false;
    }
    return isValid;
  }

  VendorBankForm = new FormGroup({
    VendorBankAccountId: new FormControl(0),
    VendorId: new FormControl('', Validators.required),
    VendorCode: new FormControl('', Validators.required),
    AccountHolderName: new FormControl('', Validators.required),
    BankName: new FormControl('', Validators.required),
    AccountNumber: new FormControl('', Validators.required),
    IFSC: new FormControl('', Validators.required)
  });

  onSubmit() {
    this.submitted = true;

    if (this.VendorBankForm.invalid) {
      this.VendorBankForm.markAllAsTouched();
      return;
    }

    const data = this.VendorBankForm.value;

    if (data.VendorBankAccountId && data.VendorBankAccountId > 0) {
      this.updateVendorBank(data);
    } else {
      this.saveVendorBank(data);
    }
  }



  saveVendorBank(data: any) {
    this.loader = true;
    data.CreatedBy = localStorage.getItem('username');

    this.vendorService.CreateVendorBank(data).subscribe({
      next: (res: any) => {
        this.loader = false;
        if (res.success) {
          this.messageService.add({
            severity: 'success',
            summary: 'Saved',
            detail: 'Vendor bank saved successfully'
          });
          this.ref.close(true);
        }
      },
      error: () => {
        this.loader = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: 'Failed to save vendor bank'
        });
      }
    });
  }



  updateVendorBank(data: any) {
    this.loader = true;
    data.UpdatedBy = localStorage.getItem('username');

    this.vendorService.updateVendorBank(data).subscribe({
      next: (res: any) => {
        this.loader = false;
        if (res.success) {
          this.messageService.add({
            severity: 'success',
            summary: 'Updated',
            detail: 'Vendor bank updated successfully'
          });
          this.ref.close(true); 
        }
      },
      error: () => {
        this.loader = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: 'Failed to update vendor bank'
        });
      }
    });
  }






}
